import React from 'react'
import {
   AIPoweredAudienceInsightsIcon,
   AIPoweredEngagementToolsIcon,
   ContinuousSupportIcon,
   CustomMediaPlatformsIcon,
   CustomSocialNetworksIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureCompliantIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom Media Platforms',
      subtitle: 'Tailored Streaming & Content Apps',
      description:
         'We build custom media platforms, including video streaming, music apps, and live event streaming, ensuring seamless content experiences.',
      icon: <CustomMediaPlatformsIcon />,
   },
   {
      title: 'AI-Powered Audience Insights',
      subtitle: 'User Behavior & Content Analytics',
      description:
         'We implement AI-driven analytics that track user engagement, content popularity, and sentiment analysis, helping businesses optimize content strategies.',
      icon: <AIPoweredAudienceInsightsIcon />,
   },
   {
      title: 'Secure & Copyright Protection',
      subtitle: 'Digital Rights & Anti-Piracy Measures',
      description:
         'We ensure DRM, GDPR, and media compliance standards, integrating AI-powered fraud detection and secure monetization models.',
      icon: <SecureCompliantIcon />,
   },
   {
      title: 'Seamless System Integration',
      subtitle: 'Social Media, CDN & Payment Gateways',
      description:
         'We develop cloud-based media platforms that integrate with CDN, payment gateways, AI editing tools, and social media platforms, ensuring efficient content delivery.',
      icon: <SeamlessIntegrationIcon />,
   },
   {
      title: 'Scalable Cloud-Based Solutions',
      subtitle: 'Optimized Performance & Growth',
      description:
         'Our cloud-powered media solutions support real-time data synchronization, global content delivery, and high-speed performance, enabling business expansion.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Continuous Support & Upgrades',
      subtitle: 'Feature Enhancements & Maintenance',
      description:
         'We deliver 24/7 technical support, security patches, and feature upgrades to keep media platforms competitive and future-proof.',
      icon: <ContinuousSupportIcon />,
   },
];
 
function MediaWhyChoose() {
   return (
      <>
         <WhyChooseOur
         classCustom='fintech_custom_why_choose'
            title={
               'Why Choose Our Gaming & Sports Software Development Services?'
            }
            desc={
               'We create safe, scalable, and innovative media and entertainment products that enrich content development, streamline delivery, and boost audience interactions. Here’s why businesses choose Benzatine:'
            }
            cardData={featureCards}
            otherUi={true}
         />
      </>
   )
}

export default MediaWhyChoose
